import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPage.css';

export default function TermsPage() {
  const navigate = useNavigate();
  return (
    <div className="static-page">
      <div className="static-nav">
        <button className="static-back" onClick={() => navigate(-1)}>← Back</button>
        <span className="static-nav-logo display-font">World Cup Pick'em</span>
      </div>
      <div className="static-content">
        <h1>Terms of Service</h1>
        <p className="static-updated">Last updated: March 27, 2026</p>

        <h2>1. Acceptance of Terms</h2>
        <p>By creating an account or using World Cup Pick'em ("the Service"), you agree to these Terms of Service. If you do not agree, do not use the Service.</p>

        <h2>2. Description of Service</h2>
        <p>World Cup Pick'em is a free, browser-based prediction league platform for the 2026 FIFA World Cup. Users can create leagues, invite others, and make match predictions to compete on a leaderboard.</p>

        <h2>3. Eligibility</h2>
        <p>You must be at least 13 years old to use the Service. By registering, you confirm that you meet this requirement.</p>

        <h2>4. User Accounts</h2>
        <p>You are responsible for maintaining the security of your account credentials. You must provide accurate information during registration. Each person may only maintain one account.</p>

        <h2>5. User Conduct</h2>
        <p>You agree not to use the Service to: (a) harass, abuse, or harm others; (b) submit false or misleading information; (c) attempt to gain unauthorized access to any part of the Service; (d) use automated tools to access or interact with the Service.</p>

        <h2>6. Picks and Scoring</h2>
        <p>All picks are final once the round lock time has passed. Points are awarded automatically based on match results. The Service makes no guarantee of accuracy or availability during live matches. Scoring decisions are final.</p>

        <h2>7. Leagues and Commissioners</h2>
        <p>League commissioners are responsible for managing their leagues. Deleting a commissioner account will permanently delete all associated leagues and picks after a 48-hour grace period. This action cannot be undone.</p>

        <h2>8. Intellectual Property</h2>
        <p>All content, design, and code in the Service is owned by World Cup Pick'em. You may not copy, reproduce, or distribute any part of the Service without prior written consent.</p>

        <h2>9. Disclaimers</h2>
        <p>The Service is provided "as is" without warranty of any kind. We do not guarantee uninterrupted access, accuracy of scores or standings, or that the Service will meet your expectations.</p>

        <h2>10. Limitation of Liability</h2>
        <p>To the fullest extent permitted by law, World Cup Pick'em shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service.</p>

        <h2>11. Changes to Terms</h2>
        <p>We may update these Terms at any time. Continued use of the Service after changes constitutes acceptance of the updated Terms.</p>

        <h2>12. Contact</h2>
        <p>Questions about these Terms can be directed to the platform administrator.</p>
      </div>
    </div>
  );
}
